import { render, staticRenderFns } from "./ScriveAccountConfiguration.vue?vue&type=template&id=cfe2161e&"
import script from "./ScriveAccountConfiguration.vue?vue&type=script&lang=ts&"
export * from "./ScriveAccountConfiguration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports